import { connect } from 'react-redux';

import { actions as authActions } from 'modules/auth';

import Header from '../components/Header';

export default connect(null, dispatch => ({
    handleLogout: () => {
        dispatch(authActions.logoutRequest());
    },
}))(Header);
